var AdaptiveImage = require( "../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "141771cd4aa9785b90d87be703ce7fe7.png",
    width: 261,
    height: 270
});